import {
  STORE_APPLICATION,
} from 'ActionTypes/application';

const storeApplicationAction = payload => dispatch => dispatch({
  data: {
    applicationId: payload.applicationId,
    channel: payload.channel,
    customerId: payload.customerId,
    customerName: payload.customerName,
    productType: payload.productType,
  },
  type: STORE_APPLICATION,
});

export default storeApplicationAction;
